import React, { FC } from 'react';

import { Select, SelectProps } from '../Select/Select';
import { SelectOption } from '../Select/SelectItem';
import { Prioridades } from 'model/solicitacao/PrioridadeSolicitacao';
import { PrioridadeTag } from './PrioridadeTag';
import { PrioridadesSelectOptions } from './PrioridadesSelectOptions';


export const PrioridadeSelect: FC<SelectProps> = (props) => {
  if (props.readonly) {
    const prioridadeSelect = props.value as SelectOption|undefined

    if (prioridadeSelect) {
      const prioridade = Prioridades.byId(prioridadeSelect.value)
      return <PrioridadeTag prioridade={prioridade} />
    }

    return <></>
  }

  const prioridades = PrioridadesSelectOptions.asArray();

  return <Select
    {...props}

    placeholder="Defina uma prioridade"

    defaultValue={prioridades[0]}
    options={prioridades}
  />;
}
